app.component("eOrdersMenu", {
	templateUrl: "app/src/js/components/eOrders/eOrdersMenu/eOrdersMenu.html",
	controller: "eOrdersMenuController",
	bindings: {
		hide: "&",
		eOrdersStatus: "=",
	},
});

app.controller("eOrdersMenuController", [
	"$scope",
	"$window",
	"EOrdersAPI",
	"CurrentPatient",
	"$modal",
	"$mdDialog",
	"$timeout",
	"Session",
	"EORDER_PROVIDERS",
	function ($scope, $window, EOrdersAPI, CurrentPatient, $modal, $mdDialog, $timeout, Session, EORDER_PROVIDERS) {
		$scope.API = EOrdersAPI;
		$scope.PROVIDERS = EORDER_PROVIDERS;

		$scope.$mdDialog = $mdDialog;

		const disabledFlags = {
			[EORDER_PROVIDERS.MEDLAB]: "isMedlabDisabled",
			[EORDER_PROVIDERS.PATHLAB]: "isPathlabDisabled",
			[EORDER_PROVIDERS.AWANUI]: "isAwanuiDisabled",
		};

		// Awanui is told which facility the order came from, and won't open without one. The practice's
		// HPI facility ID is set in Settings > Practice details.
		$scope.awanuiNeedsFacility = () => !(Session.practice && Session.practice.hpi_facility_number);

		//Opened the e-orders screen using a static provider string (eOrderEnum)
		//Can be replaced with a function that opens a new window after calling the eOrders API endpoint.
		$scope.openEOrders = (eOrderEnum) => {
			if (eOrderEnum === EORDER_PROVIDERS.AWANUI && $scope.awanuiNeedsFacility()) {
				return;
			}
			$scope.API.isProcessing = true;
			//Gets the eOrders provider URL, using a static provider string, and the current patients id.
			$scope.API.getEOrderProviderURL(eOrderEnum, CurrentPatient.patient.id)
				.then(
					(resp) => {
						const status = $scope.$ctrl.eOrdersStatus;
						const flag = disabledFlags[eOrderEnum];
						status[flag] = true;

						const win = $window.open(
							resp.data.url,
							"_blank",
							"location=no,toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=1000,height=800"
						);
						const enableLink = () => {
							status[flag] = false;
						};

						// A blocked popup returns null - there is no window to wait on, so re-enable now.
						if (!win) {
							enableLink();
							return;
						}

						// This menu is hidden (and its scope destroyed) straight after, so the flag is reset
						// through $timeout, which still runs a digest for the header that owns it.
						const timer = setInterval(() => {
							if (win.closed) {
								clearInterval(timer);
								$timeout(enableLink);
							}
						}, 500);
					},
					() => {
						   $scope.serverErrorModal = $modal({
								scope: $scope,
								templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
								show: true,
								title: "CatTrax has encountered an error",
							});
					}
				)
				.then(() => {
					$scope.API.isProcessing = false;
					$scope.$ctrl.hide();
				});
		};

		$scope.openEOrdersHelp = () => {
			$scope.$ctrl.hide();

			$mdDialog.show({
				controller: "eOrdersMenuController",
				templateUrl: "app/src/js/components/eOrders/eOrdersMenu/modal.eorders-help.tpl.html",
				scope: $scope.$new(true),
				preserveScope: false
			})
		}
	},
]);
